import { apiClient } from './config'

export const chatsService = {
  async getGroups(params = {}) {
    const query = new URLSearchParams()
    if (params.type) query.append('type', params.type)
    const qs = query.toString()
    return apiClient.get(`/chats/groups${qs ? `?${qs}` : ''}`)
  },

  async getChats(params = {}) {
    const { page = 1, limit = 20, postId, peerUserId } = params
    const query = new URLSearchParams()
    query.append('page', page)
    query.append('limit', limit)
    if (postId) query.append('postId', postId)
    if (peerUserId) query.append('peerUserId', peerUserId)
    return apiClient.get(`/chats?${query.toString()}`)
  },

  async getChatById(id) {
    return apiClient.get(`/chats/${id}`)
  },

  async getMessages(chatId, params = {}) {
    const { page = 1, limit = 50, before } = params
    const queryParams = new URLSearchParams()
    queryParams.append('page', page)
    queryParams.append('limit', limit)
    if (before) queryParams.append('before', before)
    
    return apiClient.get(`/chats/${chatId}/messages?${queryParams.toString()}`)
  },

  async sendMessage(chatId, text) {
    return apiClient.post(`/chats/${chatId}/messages`, { text })
  },

  async markAsRead(chatId) {
    return apiClient.patch(`/chats/${chatId}/read`)
  },

  async requestAdminHelp(chatId) {
    return apiClient.post(`/chats/${chatId}/admin-help`)
  },
}
